import {Box, HStack, Icon, Text, ThemeColorPath, ThemeIconKey} from 'platform/foundation';
import {match} from 'ts-pattern';

import {ReactNode} from 'react';

import {suffixTestId, TestIdProps} from 'shared/web';

interface AlertProps extends TestIdProps {
  variant?: 'success' | 'warning' | 'neutral';
  icon?: ThemeIconKey;
  children: ReactNode;
}

export function Alert(props: AlertProps) {
  const backgroundColor = match<string | undefined, ThemeColorPath>(props.variant)
    .with('success', () => 'palettes.green.20.100')
    .with('warning', () => 'palettes.yellow.20.100')
    .otherwise(() => 'palettes.neutral.20.100');

  const iconColor = match<string | undefined, ThemeColorPath | undefined>(props.variant)
    .with('warning', () => 'severity.warning')
    .with('success', () => 'severity.success')
    .otherwise(() => undefined);

  return (
    <Box
      backgroundColor={backgroundColor}
      borderRadius="small"
      padding={4}
      role="alert"
      data-testid={suffixTestId('alert', props)}
    >
      <HStack spacing={6} align="center">
        <Icon
          value={props.icon}
          color={iconColor}
          size={7}
          data-testid={suffixTestId('alertIcon', props)}
        />
        <Text size="small" data-testid={suffixTestId('alertText', props)}>
          {props.children}
        </Text>
      </HStack>
    </Box>
  );
}
